(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crwn-ingredient-explorer"] && !Shopify.designMode) return;
  try {
    
  class CrwnIngredientExplorer extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;

      this.activeIndex = 0;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.selectors = this.querySelector('.crwn-ix__selectors');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onClick);
        tab.addEventListener('keydown', this.onKeydown);
      });

      if (this.selectors) {
        this.selectors.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.onClick);
        tab.removeEventListener('keydown', this.onKeydown);
      });
      if (this.selectors) {
        this.selectors.removeEventListener('scroll', this.onScroll);
      }
    }

    onClick(event) {
      const index = Number(event.currentTarget.dataset.index);
      this.activate(index, true);
    }

    onKeydown(event) {
      const key = event.key;
      let next = null;
      if (key === 'ArrowRight' || key === 'ArrowDown') next = this.activeIndex + 1;
      else if (key === 'ArrowLeft' || key === 'ArrowUp') next = this.activeIndex - 1;
      else if (key === 'Home') next = 0;
      else if (key === 'End') next = this.tabs.length - 1;
      else return;

      event.preventDefault();
      if (next < 0) next = this.tabs.length - 1;
      if (next > this.tabs.length - 1) next = 0;
      this.activate(next, true);
      this.tabs[next].focus();
    }

    onScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        const rect = this.selectors.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        let closest = 0;
        let min = Infinity;
        this.tabs.forEach((tab, i) => {
          const tabRect = tab.getBoundingClientRect();
          const dist = Math.abs(tabRect.left + tabRect.width / 2 - center);
          if (dist < min) {
            min = dist;
            closest = i;
          }
        });
        if (closest !== this.activeIndex) this.activate(closest, false);
      });
    }

    activate(index, scrollIntoView) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;

      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });

      this.panels.forEach((panel, i) => {
        const on = i === index;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });

      if (scrollIntoView && this.selectors && window.matchMedia('(max-width: 989px)').matches) {
        const tab = this.tabs[index];
        if (tab) {
          this.selectors.scrollTo({
            left: tab.offsetLeft - this.selectors.offsetLeft,
            behavior: 'smooth',
          });
        }
      }
    }
  }

  if (!customElements.get('crwn-ingredient-explorer')) {
    customElements.define('crwn-ingredient-explorer', CrwnIngredientExplorer);
  }

  document.addEventListener('shopify:block:select', (event) => {
    const host = event.target.closest('crwn-ingredient-explorer');
    if (!host || typeof host.activate !== 'function') return;
    const panel = event.target.closest('[role="tabpanel"]');
    if (panel && panel.dataset.index != null) {
      host.activate(Number(panel.dataset.index), true);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
